import { tv } from 'tailwind-variants';

export const loaderContainer = tv({
  base: 'flex items-center justify-center',
  defaultVariants: {
    blockPage: false,
  },
  variants: {
    blockPage: {
      false: 'absolute inset-0',
      true: 'fixed inset-0 z-50 bg-black bg-opacity-30',
    },
  },
});
